<template>
	<t-input-wrapper
		:label="label"
		:description="description"
		:hint="hint"
		:isInvalid="isInvalid"
		:validationMessage="validationMessage"
		:warningMessage="warningMessage"
	>
		<div class="wrapper">
			<div class="icon-wrapper">
				<t-timpex-icon class="icon" type="bp" icon="search" />
			</div>
			<t-text-input
				ref="input"
				:placeholder="placeholder"
				:width="width"
				:value="value"
				:size="size"
				:disabled="disabled"
				paddingLeft="32px"
				v-on="inputWrapperListeners"
			/>
		</div>
	</t-input-wrapper>
</template>

<script>
import TTextInput from './TTextInput';
import formMixin from './formMixin';
import inputWrapperMixin from './inputWrapperMixin';
import TTimpexIcon from '../timpex/icons/TTimpexIcon';
export default {
	name: 'TSearchInput',
	components: { TTimpexIcon,TTextInput },
	mixins: [ formMixin,inputWrapperMixin ],
	methods: {
		focus() {
			this.$refs.input.focus();
		},
		blur() {
			this.$refs.input.blur();
		}
	},
};
</script>

<style lang="scss" scoped>
@import '~@/components/evergreen/scss/colors';

.wrapper {
	position: relative;
	display: flex;
}

.icon-wrapper {
	pointer-events: none;
	position: absolute;
	display: flex;
	justify-content: center;
	align-items: center;
	width: 32px;
	height: 100%;
	z-index: 3;
}

.icon {
	height: 14px;
	width: 14px;
	color: get-color($icon, 'default');
}
</style>

<docs>

```jsx noeditor
<div style="display: inline-grid; grid-row-gap: 10px; grid-template-rows: repeat(3, auto);">
	<t-search-input placeholder="Search placeholder..." />
</div>
```

### Code Example
```html
	<t-search-input placeholder="Search placeholder..." />
```
</docs>